import {
  closeAllTradesEpic,
  closeTradeEpic,
  handleChangeSymbolEpic,
  handleReconnectEpic,
  handleResubscribeSymbolEpic,
  modifyTradeEpic,
  openTradeEpic,
  refreshInitialTradingValuesEpic,
  updateTradingValuesEpic,
  changeSymbolEpic,
  refreshInitialTradingValuesOnEpic,
  cancelTradeEpic,
  updateAmountValuesEpic,
} from './TradeEpics'
import { combineEpics, createEpicMiddleware } from 'redux-observable'
import {
  getAccountsOnLoginEpic,
  getWebApiDataEpic,
  getAllowedLeveragesEpic,
  getClosedPositionsEpic,
  getClosedPositionsOnCloseTradeEpic,
  getTranslationsEpic,
  getUserTradingAccountsEpic,
  initGraphQlRepoEpic,
  refreshInfoOnAccountSwitch,
  getFavouritesEpic,
  updateFavouritesEpic,
} from './GraphQlEpics'
import {
  notifyParentAccountSwitched,
  notifyParentReady,
  startAppInitialization,
  triggerConfirmAction,
  triggerMt4Login,
  datafeedSymbolsStorageInit,
  datafeedSymbolsStorageInitForBonds,
  setLocaleOnInit,
  triggerMt4ReLogin, getSimpleSignalsOnInit, getTelegramSignalsOnInit,
} from './initializationEpics'
import {
  handleAllSubscriptionEpic,
  handleSetAssetsGroupEpic,
  handleSetAppModeEpic,
} from './mt4Epics'
import {
  disableTradeControlsEpic,
  enableTradeControlsEpic,
  enableTradeControlsOnLoginEpic,
  setTradingSymbolEpic,
  triggerPostCommandEpic,
  resetSelectionOnClosePositionEpic,
  resetPendingPositionSLTPEpic,
  resetTradePanelSLTPEpic,
  selectPositionEpic,
  resetSelectionOnCancelOrderEpic,
  setTradingSignalEpic, triggerMarketStateChanges,
} from './uiEpics'
// import { applyPostCommandEpic } from '../components/TradingChart'
import { openBondByUrl, openBondTradeEpic, updateBondTradingPaneEpic } from './bondsEpics'
import { processPositionEditInput } from '../components/PositionEdit'
import {
  chartCandlesEpic,
  chartSignalEpic,
  clearSignalEpic,
} from '../lib/charting_library/signals/ChartSignal'

const rootEpic = combineEpics<any>(
  openTradeEpic,
  openBondTradeEpic,
  cancelTradeEpic,
  closeAllTradesEpic,
  closeTradeEpic,
  modifyTradeEpic,
  handleAllSubscriptionEpic,
  handleSetAssetsGroupEpic,
  handleSetAppModeEpic,
  initGraphQlRepoEpic,
  refreshInfoOnAccountSwitch,
  getClosedPositionsEpic,
  getClosedPositionsOnCloseTradeEpic,
  handleChangeSymbolEpic,
  handleReconnectEpic,
  handleResubscribeSymbolEpic,
  getUserTradingAccountsEpic,
  getAccountsOnLoginEpic,
  getAllowedLeveragesEpic,
  getWebApiDataEpic,
  startAppInitialization,
  triggerMt4Login,
  triggerMt4ReLogin,
  notifyParentReady,
  notifyParentAccountSwitched,
  refreshInitialTradingValuesEpic,
  refreshInitialTradingValuesOnEpic,
  updateTradingValuesEpic,
  getTranslationsEpic,
  triggerConfirmAction,
  disableTradeControlsEpic,
  enableTradeControlsEpic,
  enableTradeControlsOnLoginEpic,
  changeSymbolEpic,
  setTradingSymbolEpic,
  setTradingSignalEpic,
  triggerPostCommandEpic,
  // applyPostCommandEpic,
  updateBondTradingPaneEpic,
  processPositionEditInput,
  resetSelectionOnClosePositionEpic,
  resetSelectionOnCancelOrderEpic,
  datafeedSymbolsStorageInit,
  datafeedSymbolsStorageInitForBonds,
  openBondByUrl,
  resetPendingPositionSLTPEpic,
  resetTradePanelSLTPEpic,
  setLocaleOnInit,
  updateAmountValuesEpic,
  getFavouritesEpic,
  updateFavouritesEpic,
  selectPositionEpic,
  chartCandlesEpic,
  chartSignalEpic,
  clearSignalEpic,
  triggerMarketStateChanges,
  getSimpleSignalsOnInit,
  getTelegramSignalsOnInit
)

export const epicMiddleware = createEpicMiddleware(rootEpic)
